import classNames from 'classnames';
import React, { Component, PropsWithChildren } from 'react';
import { ITextLabelProps } from './types';

export class TextLabel extends Component<PropsWithChildren<ITextLabelProps>, {}> {
  public render() {
    const { children, color = 'default', ...props } = this.props;
    const classes = classNames([
      'hlc-label',
      'label', // bootstrap class
      [`label-${color}`], // bootstrap class
    ]);
    const cursor = !!this.props.onClick || !!this.props.onMouseOver ? 'pointer' : 'unset';
    return (
      <span style={{ cursor }} className={classes} {...props}>
        {children}
      </span>
    );
  }
}

export default TextLabel;
